var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",attrs:{"text":""},on:{"click":_vm.onClick}},[(_vm.icon)?_c('v-icon',{staticClass:"mr-2",attrs:{"color":"grey"}},[_vm._v("mdi-"+_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }